// extracted by css-extract-rspack-plugin
export default {"caption":"DashboardTodoListStepNavigation_caption__btFyy"};